import listItems from "./listItems.component";

const listItemsModule = angular
  .module("app.components.listItems", [])
  .component("listItems", listItems);

export default listItemsModule;



// WEBPACK FOOTER //
// ./src/components/listItems/listItems.module.js